import React, { useEffect, useState } from 'react';
import ReactApexChart from "react-apexcharts";
import { getRangos } from '../../../domain/api/UsersApi';


export default function ChartPresion({ data }) {
    const [DataRangos, setDataRangos] = useState("")

    useEffect(async () => {
        const rangos = await getRangos('presion')
        setDataRangos(rangos.respuesta)

    }, [])
    // Extrae los valores de presión sistólica y las fechas correspondientes desde los datos
    const sistolicaValues = data.map((record) => record.sistolica);

    // Meses correspondientes a los puntos en el eje X
    const months = data.map((record) => {
        const date = new Date(record.datecreate);
        const day = date.getDate();
        const monthNames = [
            "ene", "feb", "mar", "abr", "may", "jun",
            "jul", "ago", "sep", "oct", "nov", "dic"
        ];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    });

    // Configuración de la gráfica
    const options = {
        chart: {
            id: "line-chart",
            width: "80%",
        },
        xaxis: {
            categories: months, // Usamos los meses como categorías
        },
        yaxis: {
            min: 40,
            max: 160,
            tickAmount: 3,
            labels: {
                colors: ["#005aa9"],
                formatter: function (value) {
                    return Math.round(value);
                },
            },
        },
        fill: {
            type: "gradient",
            gradient: {
                type: "vertical",
                shadeIntensity: 0.2,
                opacityFrom: 0.7,
                opacityTo: 0.7,
                stops: [0, 100],
            },
        },
        stroke: {
            width: 3,
            colors: ["#005aa9"], // Color de la línea aquí
            opacity: 3,
        },
        markers: {
            size: 4,
            colors: '#005aa9', // Color de los puntos (en este caso, el color de peso)
        },
        annotations: {
            yaxis: [
                {
                    y: 50,
                    y2: 119.9,
                    fillColor: "#005aa9", // Color del sombreado del rango óptimo
                    opacity: 0.2, // Opacidad del sombreado del rango óptimo
                },
            ],
        },
        tooltip: {
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const month = months[dataPointIndex]; // Mes correspondiente al punto
                const sistolicaValue = series[0][dataPointIndex]; // Valor de presión sistólica

                // Encuentra el rango al que pertenece el valor de sistólica actual
                let rangoDescripcion = "Desconocido";
                for (const rango of DataRangos) {
                    const parametros = JSON.parse(rango.parametros);
                    const [min, max] = parametros.sistolica.split("-").map(parseFloat);
                    if (sistolicaValue >= min && sistolicaValue < max) {
                        rangoDescripcion = rango.valor;
                        break;
                    }
                }

                return (
                    '<div className="custom-tooltip" style="height:68px; width:120px;font-size:12px;border-radius:10%;">' +
                    '<div className="tooltip-title" style="background-color: ' +
                    w.globals.stroke.colors[seriesIndex] +
                    '; color: white; padding-left: 10px; opacity:1">' +
                    month + // Mes en el título
                    '</div>' +
                    '<div className="tooltip-content" style="height: 60px;padding-top: 5px; ">' +
                    '<div className="sales-circle" style="background-color: ' +
                    w.globals.stroke.colors[seriesIndex] +
                    '; border-radius: 50%; width: 10px; height: 10px; display: inline-block; margin-right: 5px;margin-left: 10px; "></div>' +
                    '<span className="sales-text" style="font-weight: bold; margin: 0;">' +
                    'Sistolica: ' + sistolicaValue +
                    '</span>' +
                    '<div className="rango-description" style="background-color: ' +
                    w.globals.stroke.colors[seriesIndex] +
                    '; color: white; padding-left: 10px; font-weight: bold;margin-top: 10px;">' + rangoDescripcion +
                    '</div>' +
                    '</div>' +
                    '</div>'
                );
            },
        },
    };

    return (
        <div>
            <div>
                <ReactApexChart options={options} series={[{ name: "Sistolica", data: sistolicaValues }]} type="line" height={300} id="mi-grafico" />
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "-5%", marginLeft: "-30%", marginBottom: "6%" }}>
                <div style={{ marginRight: "20px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                width: "10px",
                                height: "3px",
                                backgroundColor: "#005aa9",
                                marginRight: "5px",
                            }}
                        ></div>
                        Sistolica
                    </div>
                </div>
                <div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                            style={{
                                width: "10px",
                                height: "10px",
                                backgroundColor: "#005aa9",
                                opacity: 0.2,
                                marginRight: "5px",
                            }}
                        ></div>
                        Rango Óptimo
                    </div>
                </div>
            </div>
        </div>
    );
};